export default __webpack_public_path__ + "static/media/header.0e9322bb.jpg";